<template>
  <p class="product-description-text">
    <span>
      <slot v-if="isShowableSlot"></slot>
      {{ finalText }}&nbsp;
      <a v-show="length < text.length" class="read-link" href="#" @click.prevent="toggle">{{
        link
      }}</a>
    </span>
  </p>
</template>

<script>
import truncateSave from '../../utilities/truncate';
import { animate } from 'animejs';
import debounce from 'lodash/debounce';

export default {
  name: 'product-description',
  props: {
    more: { type: String },
    dataLayerPush: { type: [Object, String] },
    length: { type: String },
    less: { type: String },
  },
  data() {
    const defaultSlotContent = this.$slots.default || [];
    const slotText = defaultSlotContent[0] ? defaultSlotContent[0].text || '' : '';
    return {
      link: this.more,
      finalText: this.truncate(slotText),
      truncated: true,
      text: slotText,
      isShowableSlot: false,
      dataLayerPushVTag: '',
    };
  },
  mounted() {
    window.onresize = debounce(() => {
      this.setHeight();
    }, 100);
  },
  methods: {
    truncate(string) {
      return truncateSave(string, this.length, { ellipsis: '...' });
    },
    setHeight() {
      /* istanbul ignore next */
      setTimeout(() => {
        animate(this.$el, {
          height: this.getHeight(),
          duration: 200,
          ease: 'outQuad',
        });
      }, 10);
    },
    getHeight() {
      const el = this.$el.querySelector('span');
      const bounds = el.getBoundingClientRect();
      return `${bounds.bottom - bounds.top}px`;
    },
    toggle() {
      if (this.truncated) {
        dataLayer.push(this.dataLayerPush);
        this.link = this.less;
        this.finalText = this.text;
        this.truncated = false;
        this.setHeight();
      } else {
        this.link = this.more;
        this.finalText = this.truncate(this.text);
        this.truncated = true;
        this.setHeight();
      }
    },
  },
};
</script>

<style lang="scss" src="./product-description.scss"></style>
